"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxIcon = void 0;
const react_1 = __importDefault(require("react"));
const CheckboxIcon = () => (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("rect", { x: "0.5", y: "0.5", width: "19", height: "19", rx: "1.5", fill: "transparent", stroke: "transparent" }),
    react_1.default.createElement("path", { d: "M5 8.69231L9.19048 13L16 6", stroke: "white", strokeWidth: "3" })));
exports.CheckboxIcon = CheckboxIcon;
